/**
 * BidirectionalViewToggle - Toggle between demand and supply perspectives
 * 
 * Demand (Away): Teams with ice available - you can go TO their rink
 * Supply (Home): Teams who want YOUR ice - they come to you
 */
export default function BidirectionalViewToggle({
  perspective = 'demand',
  onPerspectiveChange,
  demandCount = 0,
  supplyCount = 0,
  excellentCount = 0
}) {
  const tabs = [
    {
      id: 'demand',
      label: 'Away Opportunities',
      description: 'Go to their rink',
      count: demandCount,
      icon: '✈️'
    },
    {
      id: 'supply',
      label: 'Home Opportunities',
      description: 'Invite them to your rink',
      count: supplyCount,
      icon: '🏠'
    }
  ]

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-1 inline-flex gap-1">
      {tabs.map((tab) => {
        const isActive = perspective === tab.id
        
        return (
          <button
            key={tab.id}
            onClick={() => onPerspectiveChange?.(tab.id)}
            className={`
              relative px-4 py-2 rounded-md text-sm font-medium transition-all
              ${isActive 
                ? 'bg-brand-green text-white shadow-sm' 
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              }
            `}
          >
            <div className="flex items-center gap-2">
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
              {tab.count > 0 && (
                <span className={`
                  ml-1 px-2 py-0.5 rounded-full text-xs font-bold
                  ${isActive 
                    ? 'bg-white/20 text-white' 
                    : 'bg-gray-100 text-gray-600'
                  }
                `}>
                  {tab.count}
                </span>
              )}
            </div>
          </button>
        )
      })}
      
      {/* Excellent matches badge */}
      {excellentCount > 0 && (
        <div className="flex items-center ml-2 px-2 py-1 bg-green-50 rounded-md border border-green-200">
          <span className="text-xs text-green-700 font-medium">
            🟢 {excellentCount} excellent {excellentCount === 1 ? 'match' : 'matches'}
          </span>
        </div>
      )}
    </div>
  )
}
